/* ==========================================================================
   Data Helpers
   ========================================================================== */
/* eslint-disable */
/**
 * Function to prepare the data config
 * @param {object} data Object containing the data config.
 * @param {string} key Key name to start the key name value for the object values.
 * @returns {object} Config data to have available in the template
 */
function prepareDataConfig(data = {}, key = 'data') {
    const name = key;

    const result = {};
    result[`${name}Content`] = data.content || false;
    result[`${name}Id`] = data.id || false;
    result[`${name}Latitude`] = data.latitude || 0;
    result[`${name}Longitude`] = data.longitude || 0;
    result[`${name}Max`] = data.max || false;
    result[`${name}Min`] = data.min || false;
    result[`${name}Selected`] = data.selected ? '' : false;
    result[`${name}Token`] = data.token || false;
    result[`${name}Type`] = data.type || false;
    result[`${name}Value`] = data.value || false;
    result[`${name}Items`] = data.items || false;
    result[`${name}DefaultDate`] = data.defaultDate || false;

    return result;
}
/* eslint-enable */

/**
 * Function to prepare the price
 * @param {object} price Object containing the data model for the price.
 * @param {string} key Key name to start the key name value for the object values.
 * @returns {object} Price data to have available in the template
 */
function preparePrice(price = {}, key = 'price') {
    const name = key;

    const result = {};
    result[`${name}Value`] = price.value;
    result[`${name}From`] = price.from || '';
    result[`${name}Currency`] = price.currency;

    return result;
}

/**
 * Function to prepare the link
 * @param {object} link Object containing the data model for the link.
 * @param {string} key Key name to start the key name value for the object values.
 * @returns {object} Link data to have available in the template
 */
function prepareLink(link = {}, key = 'link') {
    const name = key;

    const result = {};
    result[`${name}Content`] = link.content || '';
    result[`${name}Href`] = link.href;
    result[`${name}Title`] = link.title;
    result[`${name}Target`] = link.target || '_self';
    result[`${name}Mail`] = link.mail || false;

    return result;
}

/**
 * Function to prepare an array of links
 * @param {array} link Object containing the data model for the links.
 * @param {string} key Key name to start the key name value for the object values.
 * @returns {object} Link data to have available in the template
 */
function prepareLinks(links = [], key) {
    const name = key;
    const temp = links.map(item => prepareLink(item.link, name));

    const result = {};
    result[`${name}Content`] = temp.map(item => item[`${name}Content`]);
    result[`${name}Href`] = temp.map(item => item[`${name}Href`]);
    result[`${name}Title`] = temp.map(item => item[`${name}Title`]);
    result[`${name}Target`] = temp.map(item => item[`${name}Target`]);
    result[`${name}Mail`] = temp.map(item => item[`${name}Mail`]);

    return result;
}
/**
 * Function to prepare the date of a image
 * @param {object} image Object containing the data model for the image.
 * @param {string} key Key name to start the key name value for the object values.
 * @param {object} resize Resize configuration for the image.
 * @returns {object} Image data to have available in the template
 */
function prepareImage(image = {}, key = 'image', resize = {}) {
    const name = key;
    const tempResize = {
        operation: resize.operation || 'resize',
        suboperation: resize.suboperation || 'crop',
        height: resize.height || 75,
        width: resize.width || 75,
        quality: resize.quality || 97
    };

    const result = {};
    result[`${name}Src`] = image.src;
    result[`${name}Alt`] = image.alt;
    result[`${name}Alternative`] = image.alternative;
    result[`${name}Title`] = image.title;
    result[`${name}Class`] = image.carousel ? 'carousel__lazy' : 'lazy';
    result[`${name}Lazy`] = 'images/shim.gif';
    result[`${name}Carousel`] = !!image.carousel;
    result.resizeData = tempResize;

    // Add link to image
    if (image.link) result[`${name}Link`] = prepareLink(image.link);

    return result;
}

/**
 * Function to format the date
 * @param {object} date Object containing the date
 * @returns {string} Date in format yyyy-mm-dd
 */
function formatDate(date = new Date()) {
    const rDate = date.getDate();
    const rMonth = date.getMonth() + 1;
    const rYear = date.getFullYear();

    return `${rYear}-${rMonth < 10 ? `0${rMonth}` : rMonth}-${rDate}`;
}

/**
 * Function to create random id
 * @param {string} key String containing the key to prepend the id
 * @param {Number} max Max number to calculate random number to
 * @returns {string} Random id with format key-number
 */
function randomId(key = 'id', max = 1000) {
    return `${key}-${Math.floor(Math.random() * max)}`;
}

/**
 * Function to add styles to the config
 * @param {object} data Object containing the data of the model part
 * @param {Array} styles Collection of styles to add to the data
 * @returns {object} Data object with the styles added to the config
 */
function addStyle(data, styles = []) {
    const result = data;
    const css = styles;

    result.config = data.config ? data.config : {};
    result.config.styles = result.config ? result.config.styles : [];

    result.config.styles = css;

    return result;
}

/**
 * Function to add styles to the config
 * @param {object} data Object containing the data of the model part
 * @param {object} values Collection of data-values to add to the data
 * @returns {object} Data object with the data added to the config
 */
function addData(data, dataValue = {}) {
    const result = data;

    result.config = data.config ? data.config : {};
    result.config.data = result.config
        ? {
              ...result.config.data,
              ...dataValue
          }
        : dataValue;

    // result.config.data = css;

    return result;
}

module.exports = {
    prepareDataConfig,
    preparePrice,
    prepareLink,
    prepareLinks,
    prepareImage,
    formatDate,
    randomId,
    addStyle,
    addData
};
